import MasterSystemModalContainer from './containers/MasterSystemModalContainer'

export default MasterSystemModalContainer
